import React from 'react';
import './Header.css';
import { Player } from '@lottiefiles/react-lottie-player';

const Header = ({ headTitle, isChanged }) => {
    return (
        <div className="head-container">
            <Player
                loop
                autoplay
                className={`head-image ${
                    isChanged ? 'head-image-expanded' : 'head-image-contracted'
                }`}
                src="https://lottie.host/f28ef1ab-56c3-4143-ba35-b7ad3e6d4729/A3LwYPmac0.json"
            />

            <h1
                className={`head-text ${
                    isChanged ? 'head-text-expanded' : 'head-text-contracted'
                }`}
            >
                {headTitle}
            </h1>
        </div>
    );
};

export default Header;
